import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ValidationUtils } from 'src/app/shared/utils/validation.utils';

@Injectable()
export class PaypalService {

  private paypalUpdateEndPointURL = 'paypal/updatePayment';
  constructor(private http: HttpClient) { }

    // add paypal payment to the DB
    addPaypalTransaction (paypalTransactionObject) : Observable<any> {
      return this.http.post(this.paypalUpdateEndPointURL, paypalTransactionObject);
    }

    getAllSubcriptions (make) : Observable<any> {
      const sanitizedMake = ValidationUtils.sanitizeRemoveSymbols(make);
      return this.http.get(`paypal/subcriptions/${sanitizedMake}`);
    }

    getActiveSubcription (userID) : Observable<any> {
      return this.http.get(`paypal/activesubscription/${userID}`);
    }

    hasActiveSubcription (userID) : Observable<any> {
      return this.http.get(`paypal/hasActiveSubscription/${userID}`);
    }

    getPaypalEnvironment () : Observable<any> {
      return this.http.get(`paypal/getPaypalEnvironment`);
    }
}
